import React from 'react'
import styled from 'styled-components'

import { GOTHAM_BOLD } from '../../styles/typography'
import { mediaMax } from '@styles/sizes';

import Container from '../Container/Container'

const TemplateTitle = styled.h1`
  font-family: ${GOTHAM_BOLD};
  font-size: 64px;
  margin-bottom: 56px;
  ${mediaMax.tablet`
    font-size: 48px;
    margin-bottom: 40px;
  `}
`

const Title = ({ children }) => {
  return (
    <Container large>
      <TemplateTitle>{children}</TemplateTitle>
    </Container>
  )
}

export default Title